import APIRequestState from '../_util/api-request';

class MeState extends APIRequestState {
  get method() { return 'GET'; }
  get url() { return '/me'; }
}

export default MeState;



// WEBPACK FOOTER //
// ./spa/state/session/me.jsx